export default "__VITE_ASSET__p1cXT8zq__"